import { Modal } from 'react-bootstrap';
import { Trans } from 'react-i18next';

function NewsLetterModal({pdfUrl, name, showBrochure, setShowBrochure}) {
    return (
        <>
            <Modal show={showBrochure} fullscreen={true} onHide={() => setShowBrochure(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>{name}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <iframe
                        src={pdfUrl}
                        title={name}
                        width="100%"
                        height="100%"
                        style={{ border: 'none', minHeight: '80vh' }}
                    >
                    </iframe>
                    <p style={{ marginTop: '1rem' }}>
                        <Trans i18nKey="Preview" /> not available?{' '}
                        <a href={pdfUrl} target="_blank" rel="noopener noreferrer">
                            Open in new tab
                        </a>
                        .
                    </p>
                </Modal.Body>
            </Modal>
        </>
    );
}

export default NewsLetterModal;